import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=4a395f5a&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=4a395f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a395f5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a395f5a')) {
      api.createRecord('4a395f5a', component.options)
    } else {
      api.reload('4a395f5a', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=4a395f5a&scoped=true&", function () {
      api.rerender('4a395f5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yOJNBFr2rFxh/JS/comp/PopupDialog.vue"
export default component.exports